import * as React from 'react'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'

import { Text } from "../../Text/Text"


interface OwnProps {
  eyebrow?: string
  imageAlt?: string
  imageData?: IGatsbyImageData
  intro?: string
  title: string
}

type ThreeColumnItemProps = OwnProps

export const ThreeColumnItem: React.FC<ThreeColumnItemProps> = ({
  eyebrow,
  imageAlt,
  imageData,
  intro,
  title
}) => {
  return (
    <div className="mt-8 md:mt-0">
      {imageData && imageAlt && (
        <GatsbyImage
          alt={imageAlt}
          image={imageData}
        />
      )}
      {eyebrow && (
        <div className="mt-8">
          <Text variant="body-caps">{eyebrow}</Text>
        </div>
      )}
      <div className="mt-0">
        <Text variant="large-subheader">{title}</Text>
      </div>
      {intro && (
        <div className="mt-2">
          <Text variant="body">{intro}</Text>
        </div>
      )}
    </div>
  )
}
